import { AppState } from "../../../store/app.state";
import { connect } from "react-redux";
import { Dispatch } from "redux";

import KeyValueTableComponent from "./key-value-table.component";
import { ConnectedState, ConnectedDispatch, OwnProps } from "./key-value-table.types";

import { getFilteredFerkel } from "../../../store/ferkel/ferkel.selectors";
import {
  getCurrentRecordId,
  getGivenDataByWorkflowId,
} from "../../../store/prozess-events/prozess-events.selectors";
import { getIsManuallyEmpty, isEditModeActivated } from "../../../store/common/common.selectors";
import {
  givenDataApplied,
  prozessDataChanged,
  ProzessInputData,
} from "../../../store/prozess-events/prozess-events.actions";
import { getEditedValueByWorkflowId } from "../../../store/captured-records/captured-records.selectors";

const mapStateToProps = (state: AppState, ownProps: OwnProps): ConnectedState => {
  const workflowId = ownProps.prozess.workflowId!;

  return {
    givenData: getGivenDataByWorkflowId(workflowId)(state),
    prevRecordId: getCurrentRecordId(state),
    isManuallyEmpty: getIsManuallyEmpty(state),
    isEditing: isEditModeActivated(state),
    editedValue: getEditedValueByWorkflowId(workflowId)(state),
    ferkel: getFilteredFerkel(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch): ConnectedDispatch => ({
  onChanged: (prozessInputData: ProzessInputData) => dispatch(prozessDataChanged(prozessInputData)),
  givenDataApplied: (workflowId: number) => dispatch(givenDataApplied(workflowId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(KeyValueTableComponent);
